import { CreateRatingDto, FedexRatingResponseDto } from "../types/api/api-types";
import { useMutation } from "@tanstack/react-query";
import { axiosApi } from "./axios";

const getFedexRating = async (payload: CreateRatingDto) => {
  const response = await axiosApi.post<FedexRatingResponseDto>(`/ratings/fedex`, payload);
  return response.data;
};

export const useGetFedexRating = () => {
  return useMutation({
    mutationFn: getFedexRating,
  });
};
